export default "__VITE_ASSET__CqU3FY5E__"